module.exports = __webpack_public_path__ + "file-text.svg";